export type ReleaseHold = () => void;
export type ReleaseHoldProvider = (reason: string) => ReleaseHold;

let provider: ReleaseHoldProvider | null = null;

/**
 * Keeps low-level modules independent of the update store. Importing the store from the API
 * client would create a cycle through telemetry, which itself reads client authentication state.
 */
export function setReleaseHoldProvider(next: ReleaseHoldProvider | null): void {
  provider = next;
}

export function holdRelease(reason: string): ReleaseHold {
  return provider?.(reason) ?? (() => undefined);
}
